import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public API
export const getSettings = () => api.get('/settings');
export const getServices = () => api.get('/services');
export const getServiceBySlug = (slug) => api.get(`/services/${slug}`);
export const getGallery = () => api.get('/gallery');
export const getAdditionalServices = () => api.get('/additional-services');
export const getFAQ = () => api.get('/faq');
export const submitContactForm = (data) => api.post('/contact', data);
export const getAboutFeatures = () => api.get('/about-features');

// Admin API
export const adminLogin = (credentials) => api.post('/admin/login', credentials);

export const getDashboardStats = () => api.get('/admin/dashboard-stats');
export const getContacts = () => api.get('/admin/contacts');
export const updateContact = (id, data) => api.put(`/admin/contacts/${id}`, data);

export const updateSettings = (data) => api.put('/admin/settings', data);

export const createService = (data) => api.post('/admin/services', data);
export const updateService = (id, data) => api.put(`/admin/services/${id}`, data);
export const deleteService = (id) => api.delete(`/admin/services/${id}`);

export const addGalleryImage = (data) => api.post('/admin/gallery', data);
export const deleteGalleryImage = (id) => api.delete(`/admin/gallery/${id}`);

export const createFAQ = (data) => api.post('/admin/faq', data);
export const updateFAQ = (id, data) => api.put(`/admin/faq/${id}`, data);
export const deleteFAQ = (id) => api.delete(`/admin/faq/${id}`);

export default api;
